import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TableTemplate from '../TableTemplate';
import Widgets from './Widgets';
import keycloak from "../../../Keycloak";
import {
    getCandidatesByCompanyId,
    getCandidatesByJobId,
    getSelectedCandidatesByCompanyId
} from "../../../utilities/HrAPI";
import { useLocation } from "react-router-dom";
import { getJobById } from "../../../utilities/cvAPI";
import { useClient } from "../../../utilities/ClientProvider";

const Candidates = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const jobId = searchParams.get('jobID');

    const [candidatesList, setCandidatesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [jobTitle, setJobTitle] = useState("");
    const [filteredCandidates, setFilteredCandidates] = useState([]);
    const { client } = useClient();

    const callGetJobTitle = useCallback(async () => {
        try {
            const job = await getJobById(jobId);
            setJobTitle(job.jobTitle);
        } catch (e) {
            console.log(e);
        }
    }, [setJobTitle, jobId]);

    const callCandidatesByJobId = useCallback(async () => {
        if (keycloak) {
            try {
                const candidates = await getCandidatesByJobId(jobId, keycloak.token);
                if ( candidates) {
                    setCandidatesList(candidates);
                    setFilteredCandidates(candidates);
                    setLoading(false);
                }
            } catch (e) {
                console.log(e);
            }
        }
    }, [jobId]);

    const getAllCandidatesAndUpdateUI = useCallback(async () => {
        if (keycloak) {
            try {
                if (client !== 'all') {
                    const candidateInfo = await getSelectedCandidatesByCompanyId(client, keycloak.token);
                    setCandidatesList(candidateInfo);
                    setFilteredCandidates(candidateInfo);
                } else {
                    const candidates = await getCandidatesByCompanyId(keycloak.token);
                    setCandidatesList(candidates);
                    setFilteredCandidates(candidates);
                }
                setLoading(false);
            } catch (e) {
                setFilteredCandidates([]);
                setLoading(false);
            }
        }
    }, [client]);

    useEffect(() => {
        if ((keycloak.hasResourceRole("hr_admin") || keycloak.hasResourceRole("client_recruiter")) && !jobId) {
            getAllCandidatesAndUpdateUI();
        } else if ((keycloak.hasResourceRole("hr_admin") || keycloak.hasResourceRole("client_recruiter")) && jobId) {
            callCandidatesByJobId();
            callGetJobTitle();
        }
    }, [getAllCandidatesAndUpdateUI, callGetJobTitle, callCandidatesByJobId, jobId]);

    const columns = [
        { id: 'fullName', label: 'Full Name', minWidth: 150 },
        { id: 'appliedOn', label: 'Applied On', minWidth: 150 },
        { id: 'cvScore', label: 'CV Score', minWidth: 150 },
        { id: 'status', label: 'Current status', minWidth: 150 },
        { id: 'popOver', label: 'Action', minWidth: 150 }
    ];

    const filterCandidates = (value) => {
        if (value === "ALL") {
            setFilteredCandidates(candidatesList.filter(candidate => candidate.status.name !== 'DECLINE'));
        } else if (value === "NEW") {
            setFilteredCandidates(candidatesList.filter(candidate => candidate.status.name === "AWAITING_SCORE"));
        } else if (value === "IN_PROGRESS") {
            setFilteredCandidates(candidatesList.filter(candidate => candidate.status.name === 'INITIAL_INTERVIEW' || candidate.status.name === 'NOTIFY_MANAGER'));
        } else if (value === "SHORT_LISTED") {
            setFilteredCandidates(candidatesList.filter(candidate => candidate.status.name === 'FOLLOWUP_INTERVIEW' || candidate.status.name === 'PSYCHOMETRICS' || candidate.status.name === 'REFERENCE_CHECKS'));
        } else if (value === "JOB_OFFER") {
            setFilteredCandidates(candidatesList.filter(candidate => candidate.status.name === 'OFFER_LETTER'));
        } else if (value === "DECLINE") {
            setFilteredCandidates(candidatesList.filter(candidate => candidate.status.name === 'DECLINE'));
        }
    };

    const handleUpdatedCandidates = useCallback((updatedCandidates) => {
        setFilteredCandidates(updatedCandidates);
    }, []);

    return (
        <div style={{
            width: '90%',
            marginLeft: '5%',
            marginTop: '20px',
            marginBottom: '2%'
        }}
             data-testid={'candidatesDashboard'}>
            <Grid container spacing={2}>
                <Grid item xs={1.5}>
                    <h1>
                        Candidates
                    </h1>
                </Grid>
                <Grid item xs={12}>
                    <Widgets candidates={filteredCandidates} filterCandidates={filterCandidates} />
                </Grid>
                <Grid item xs={12}>
                    <h2 data-testid={"job-title"}>
                        {jobTitle}
                    </h2>
                </Grid>
                <Grid item xs={12}>
                    {loading ? (
                        <p></p>
                    ) : (
                        <TableTemplate columnsArray={columns} data={filteredCandidates} search={true} filter={"All"} updatedCandidates={handleUpdatedCandidates} />
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

export default Candidates;